import React from 'react';
import RedditIcon from './reddit.svg';
const BrandColor = '#FF4500';
export const Reddit = () => React.createElement(RedditIcon, { fill: BrandColor });
